var React = require('react');

function MailInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"mail_outline_24px"},React.createElement("path",{"id":"icon/communication/mail_outline_24px","fillRule":"evenodd","clipRule":"evenodd","d":"M41.6668 8.33333H8.33342C6.04175 8.33333 4.18758 10.2083 4.18758 12.5L4.16675 37.5C4.16675 39.7917 6.04175 41.6667 8.33342 41.6667H41.6668C43.9584 41.6667 45.8334 39.7917 45.8334 37.5V12.5C45.8334 10.2083 43.9584 8.33333 41.6668 8.33333ZM8.33342 16.6667L25.0001 27.0833L41.6667 16.6667V37.5H8.33342V16.6667ZM8.33342 12.5L25.0001 22.9167L41.6667 12.5H8.33342Z","fill":"white"})));
}

MailInline.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50","fill":"none"};

module.exports = MailInline;

MailInline.default = MailInline;
